module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "content"
    }
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('a', {
    attrs: {
      "href": "#/06_Acknowledgements"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('a', {
    attrs: {
      "href": "#/07_ch1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")]), _vm._v(" Alarums and Incursions")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('a', {
    attrs: {
      "href": "#/16_ch2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")]), _vm._v(" Medieval Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/26_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Sea Beggars")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/33_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4 ")]), _vm._v("The Sinking of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/44_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")]), _vm._v(" Insula Infortunata")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/47_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")]), _vm._v(" ‘That Man of Blood’")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/59_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")]), _vm._v(" In Search of Michal Morey")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/68_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")]), _vm._v(" Tom Boulter the Highwayman")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/73_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")]), _vm._v(" The Governor’s Wife or Sir Richard Worse-than-Sly")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/77_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")]), _vm._v(" The Loss of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Royal George")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/80_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")]), _vm._v(" Watching the Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/94_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")]), _vm._v(" The Legend of Sophie Dawes")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/102_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")]), _vm._v(" ‘For Those in Peril…’")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/113_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")]), _vm._v(" ‘Nor Iron Bars a Cage…’")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/119_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")]), _vm._v(" Court News")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/122_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16 ")]), _vm._v("‘Dear Osborne…’")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/125_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17 ")]), _vm._v("Fifth Column of One")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/129_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")]), _vm._v(" ‘Look, Stranger, on This Island Now…’")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1A"
  }, [_c('span', {
    attrs: {
      "href": "#/132_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30933b31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_content.vue
// module id = 66
// module chunks = 0